import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCapIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-party-gold bg-party-cream" data-id="element-97" data-mp="4mi5dgdtryh4">
      <div className="mx-auto max-w-2xl px-3 pb-5 pt-3 text-center sm:px-5" data-id="element-98" data-mp="1297bo2fk8x8s">
        <motion.p initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="inline-flex items-center gap-1.5 rounded-full bg-party-ink px-3 py-1 font-sans text-[0.62rem] font-bold uppercase tracking-[0.12em] text-party-gold" data-id="element-99" data-mp="127ec173d7daa">
          <GraduationCapIcon size={12} data-id="element-100" data-mp="3d21uc37gquqd" />
          Método de aprendizaje paso a paso
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.04
      }} className="mt-2 font-display text-[1.55rem] font-extrabold leading-[1.1] text-party-ink sm:text-[2.1rem]" data-id="element-101" data-mp="3825zatgqudmy">
          El sistema completo para aprender Decoración de{' '}
          <span className="font-script text-[1.35em] font-normal leading-none text-party-rose" data-id="element-102" data-mp="39cpcutwbfj2d">
            Fiestas y Eventos
          </span>{' '}
          desde cero
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.08
      }} className="mx-auto mt-1.5 max-w-xl text-[0.8rem] font-medium leading-snug text-party-ink/80 sm:text-[0.92rem]" data-id="element-103" data-mp="30fy87t3p6vw6">
          Aprende a crear decoraciones completas con globos, fondos, mesas
          temáticas y estructuras, y prepárate para comenzar a ofrecer este
          servicio — sin perderte entre cientos de videos, ideas y tutoriales.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.25,
        ease: EASE,
        delay: 0.12
      }} className="mt-2 inline-block rounded-md bg-party-rose px-3 py-1.5 font-sans text-[0.65rem] font-extrabold uppercase leading-tight tracking-wide text-white sm:text-xs" data-id="element-104" data-mp="s2jj7lrcvge8">
          {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.16
      }} className="mt-2 block overflow-hidden rounded-xl border-4 border-party-gold bg-white" data-id="element-105" data-mp="1b0drtyoknpw3">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-106" data-mp="x0uxq9slif2s" />
        </motion.a>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.2
      }} className="mt-3" data-id="element-107" data-mp="3hpsen5c8br21">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-108" data-mp="21b63fwja2ym4">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-semibold text-party-ink/80" data-id="element-109" data-mp="267wjijv31u7j">
            <span className="flex items-center gap-1" data-id="element-110" data-mp="2g0c13g2gwgrw">
              <ZapIcon size={12} className="text-party-rose" data-id="element-111" data-mp="2g1wwf7wlw3qt" />
              Acceso Digital Inmediato
            </span>
            <span className="text-party-ink/40" data-id="element-112" data-mp="2p0h6xls0j73y">•</span>
            <span className="flex items-center gap-1" data-id="element-113" data-mp="2p10fibvrwj5b">
              <ShieldCheckIcon size={12} className="text-party-brown" data-id="element-114" data-mp="2tzbs2udgd7r8" />
              Garantía de 7 Días
            </span>
          </p>
        </motion.div>
      </div>
    </header>;
}